export const environment = {
    production: true,
    urlAPI: 'https://api.mileapmotor.es/api/',
    blobPublic: 'https://blobleapmotor.blob.core.windows.net/prod-leapmotor-public/',
    urlApiVideos: 'https://api.mileapmotor.es/api/Video/GetRangedVideos/',
  };